export default "__VITE_ASSET__D468EqEt__"